import { useQuoteModal } from '@/hooks/useQuoteModal';

export default function HeroSection() {
  const { open } = useQuoteModal();

  return (
    <section id="hero" className="relative min-h-[100dvh] min-h-[600px] flex items-start justify-center overflow-hidden pt-24 md:pt-40">
      {/* Background video */}
      <div className="absolute inset-0 overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover select-none"
          controlsList="nodownload"
        >
          <source
            src="https://storage.helloreaddy.io/project_files/9755469e-cfe9-4755-b8ae-44d6e19e4537/20e3f863-05ce-4470-9a36-6429a022491b_Animar_olas_de_imagen_202608061007.mp4"
            type="video/mp4"
          />
        </video>
        {/* Anti-download overlay on video */}
        <div
          className="absolute inset-0 z-10"
          onContextMenu={(e) => e.preventDefault()}
          aria-hidden="true"
        />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-1.5 rounded-full bg-black/30 backdrop-blur-sm border border-white/30 mb-4 md:mb-6">
            <div className="w-2 h-2 rounded-full bg-accent-400"></div>
            <span className="text-white font-medium text-xs md:text-sm tracking-wide uppercase">Importación Directa desde China</span>
          </div>

          {/* Tagline principal */}
          <h1 className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4 md:mb-6 [text-shadow:0_2px_16px_rgba(0,0,0,0.8)]">
            Demulsificante Ya Formulado
            <br />
            <span className="text-white">Para La Faja Petrolifera del Orinoco</span>
          </h1>

          <p className="text-white font-medium text-sm md:text-base lg:text-lg leading-relaxed max-w-2xl mx-auto mb-6 md:mb-10 [text-shadow:0_1px_8px_rgba(0,0,0,0.75)]">
            Importamos directamente desde China demulsificantes de alta efectividad, ya formulados y listos para usar
            en los campos petroleros de Venezuela. Producto certificado, logística resuelta, entrega garantizada.
          </p>

          {/* Feature pills */}
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-6 md:mb-10">
            {[
              { icon: 'ri-ship-line', text: 'Importación Directa China' },
              { icon: 'ri-shield-check-line', text: 'Aprobado por PDVSA' },
              { icon: 'ri-flask-line', text: 'Producto Ya Formulado' },
              { icon: 'ri-map-pin-line', text: 'Entrega en Venezuela' },
            ].map((item) => (
              <div
                key={item.text}
                className="inline-flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs md:text-sm font-medium"
              >
                <i className={`${item.icon} w-3 h-3 flex items-center justify-center`} />
                {item.text}
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              type="button"
              onClick={open}
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              Solicitar Cotización
              <i className="ri-arrow-right-line ml-2 text-sm"></i>
            </button>
            <a
              href="#products"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#products')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white font-semibold text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Ver Productos
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-4 md:bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 md:w-6 md:h-10 rounded-full border-2 border-white/50 flex items-start justify-center p-1 md:p-1.5">
          <div className="w-1 md:w-1.5 h-2 md:h-3 rounded-full bg-white animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}